import React, { FC } from 'react'
import { EuiFlexGroup, EuiFlexItem, EuiText, EuiSpacer } from '@elastic/eui'

interface DemographicItemProps {
    label: string
    value: string
    showSpacer?: boolean
}

const DemographicItem: FC<DemographicItemProps> = ({ label, value, showSpacer = false }) => {
    return (
        <div>
            <EuiFlexGroup alignItems="flexStart" gutterSize="s" responsive={false} style={{ marginLeft: '8px' }}>
                <EuiFlexItem grow={false} style={{ minWidth: '120px' }}>
                    <EuiText size="s">
                        <strong>{label}:</strong>
                    </EuiText>
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiText size="s">
                        {value}
                    </EuiText>
                </EuiFlexItem>
            </EuiFlexGroup>
            {showSpacer && <EuiSpacer size="s" />}
        </div>
    )
}

export default DemographicItem 